import { render, staticRenderFns } from "./ManterDashboardFormacaoEscolasView.vue?vue&type=template&id=649547d6"
import script from "./ManterDashboardFormacaoEscolasView.vue?vue&type=script&lang=js"
export * from "./ManterDashboardFormacaoEscolasView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports